export default __webpack_public_path__ + "static/media/logo-full.b8611f4a.svg";